<mat-form-field mat-input-height-small>
  <input
    data-at-installations-search-field
    [placeholder]="'+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.SEARCH' | translate"
    matInput
    [formControl]="searchValue"
    maxlength="100"
  />
  <button data-at-installations-search class="search-button" matSuffix mat-icon-button>
    <mat-icon>search </mat-icon>
  </button>
</mat-form-field>
